import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useMarket } from '../context/MarketContext';

export default function SystemStatusPanel() {
  const { connectionStatus, orderBook, isAutoTrading, messages } = useMarket();

  return (
    <div style={{ background:'#1e293b', padding:20, borderRadius:8, border:'1px solid #334155' }}>
      <h3 style={{ margin:'0 0 16px 0', fontSize:16, fontWeight:600 }}>System Status</h3>

      <KV k="FIX Connection" v={connectionStatus === 'connected' ? 'ACTIVE' : 'INACTIVE'}
          vColor={connectionStatus === 'connected' ? '#10b981' : '#ef4444'}/>
      <KV k="Market Data"
          v={(orderBook.bids.length || orderBook.asks.length) ? 'STREAMING' : 'NO DATA'}
          vColor={(orderBook.bids.length || orderBook.asks.length) ? '#10b981' : '#ef4444'}/>
      <KV k="Auto Trading" v={isAutoTrading ? 'ENABLED' : 'DISABLED'} vColor={isAutoTrading ? '#10b981' : '#ef4444'}/>
      <KV k="Messages Received" v={String(messages.length)} vColor="#3b82f6"/>
      <KV k="Order Book Entries" v={String(orderBook.bids.length + orderBook.asks.length)} vColor="#3b82f6"/>

      <div style={{
        marginTop:16, padding:12, background:'#334155', borderRadius:6,
        display:'flex', alignItems:'center', gap:8
      }}>
        <AlertTriangle size={16} color="#f59e0b"/>
        <span style={{ fontSize:12, color:'#f59e0b' }}>Live FIX Connection Active</span>
      </div>
    </div>
  );
}

function KV({ k, v, vColor }:{ k:string; v:string; vColor?:string }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
      <span style={{ fontSize:12, color:'#94a3b8' }}>{k}</span>
      <span style={{ fontSize:12, color: vColor || '#e2e8f0', fontWeight:600 }}>{v}</span>
    </div>
  );
}
